import { useState, useEffect } from 'react'

const useFetch = ({
  url,
  method = 'GET',
  body
}) => {
  const [data, setData] = useState()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState()
  const [triggered, setTriggered] = useState(false)

  const trigger = () => {
    setTriggered(true)
  }

  useEffect(() => {
    if (triggered) {
      setTriggered(false)

      const fetchProduct = async () => {
        setLoading(true)

        try {
          setError()
          let fetchOptions = {
            method,
            body: JSON.stringify(body)
          }

          const response = await fetch(url, fetchOptions).then(d => d.json())
          setData(response)
        } catch (err) {
          setError(err)
        }
        setLoading(false)
      }
      fetchProduct()
    }
  }, [triggered])

  return { data, loading, error, trigger }
}

export default useFetch
